import type { FC } from "react";

import { cn } from "@/ui/lib/utils";
import {
  SECTION_DEFAULTS,
  TSectionProps,
} from "@/ui/components/layout/Section";

export const Section: FC<TSectionProps> = (
  {
    "data-component": component = SECTION_DEFAULTS["data-component"],
    className,
    children,
    ...props
  },
) => {

  return (
    <section
      {...props}
      data-component={component}
      className={cn(
        "w-full",
        className,
      )}
    >
      { children }
    </section>
  );
};

Section.displayName = "Section";
